import { render, staticRenderFns } from "./EducationCreate.vue?vue&type=template&id=096e68f7&"
import script from "./EducationCreate.vue?vue&type=script&lang=js&"
export * from "./EducationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports